import { Anchor, token } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledAnchor = styled(Anchor)`
  color: ${token('colors.black')};

  &:visited {
    color: ${token('colors.black')};
  }
`;
